import { useEffect, useRef } from 'react';

const escapeLayers = [];
let listeningDocument = null;

const handleEscape = (event) => {
  if (event.key !== 'Escape' || event.defaultPrevented || event.isComposing) return;

  const activeLayer = escapeLayers[escapeLayers.length - 1];
  if (!activeLayer) return;

  event.preventDefault();
  event.stopPropagation();
  activeLayer.handlerRef.current?.(event);
};

const startListening = (doc) => {
  if (listeningDocument === doc) return;
  listeningDocument = doc;
  listeningDocument.addEventListener('keydown', handleEscape, true);
};

const stopListeningIfIdle = () => {
  if (escapeLayers.length || !listeningDocument) return;
  listeningDocument.removeEventListener('keydown', handleEscape, true);
  listeningDocument = null;
};

/**
 * Dismiss the most recently opened UI layer when Escape is pressed.
 * Each enabled instance joins a shared stack so one key press never closes
 * a modal and an underlying drawer/dropdown at the same time.
 */
const useEscapeKey = (onEscape, enabled = true) => {
  const handlerRef = useRef(onEscape);
  handlerRef.current = onEscape;

  useEffect(() => {
    if (!enabled || typeof document === 'undefined') return undefined;

    const layer = { handlerRef };
    escapeLayers.push(layer);
    startListening(document);

    return () => {
      const index = escapeLayers.lastIndexOf(layer);
      if (index !== -1) escapeLayers.splice(index, 1);
      stopListeningIfIdle();
    };
  }, [enabled]);
};

export default useEscapeKey;
